import React from 'react'
import AppOfficesBlockContainer from "@components/DataBlocks/OfficesContainer"


export default function officesColumn() {

	return {
		name: 'officesName',
		label: 'Offices',
		options: {
			customBodyRowRenderLite: value => <AppOfficesBlockContainer rows={value}/>,
		}
	}
}